__turbopack_context__.v({
  "container": "DisplayBlock-module__cpyfSW__container",
  "container__content": "DisplayBlock-module__cpyfSW__container__content",
  "container__content__description": "DisplayBlock-module__cpyfSW__container__content__description",
  "container__content__description__description": "DisplayBlock-module__cpyfSW__container__content__description__description",
  "container__content__description__title": "DisplayBlock-module__cpyfSW__container__content__description__title",
  "container__content__image": "DisplayBlock-module__cpyfSW__container__content__image",
});
